/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Team Member' ),
	description: __( 'Team Member Block.' ),
	icon: <Icon icon="admin-users" />,
	keywords: [
		'gutenify',
		__( 'teams' ),
		__( 'team member' ),
	],
	parent: [ 'gutenify/team' ],
	example: {
		attributes: {
			image: {
				url: '',
				id: '',
			},
		},
	},
	attributes,
	edit,
	save,
	supports: {
		html: false,
		customClassName: true,
	},
};

export { name, category, settings };
